module.exports = __webpack_public_path__ + "assets/img/a9e3c50623fcd4d4fc6c292a8155b450.png";